{
  "version": 1,
  "asset_id": "768fcce7-9bfe-4183-ac08-5834839873b6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/768fcce7-9bfe-4183-ac08-5834839873b6/austin-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/768fcce7-9bfe-4183-ac08-5834839873b6/austin-640.webp",
  "original_filename": "austin-640.webp",
  "size": 29536,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:45Z"
}
